import { Link, useParams } from "react-router-dom";
import Page from "../components/page";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import api from "../functions/api";
import moment from "moment";

const MachinesDetails = () => {
    const [date, setDate] = useState(new Date());
    const [history, setHistory] = useState(null);

    let { data } = useParams();

    data = JSON.parse(atob(data));

    const _data = `https://embpass.com/attendance/${btoa(
        JSON.stringify(data)
    )}`;
    const qr = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${_data}&margin=10`;

    const getMachineHistory = async (time = new Date()) => {
        try {
            const resp = await api.get(
                `/machine-history?machine=${data?._id}&date=${time.toString()}`
            );
            setHistory(resp);
        } catch (err) {
            console.log("🚀 ~ getMachineHistory ~ err:", err);
        }
    };

    const onChange = (newDate) => {
        setDate(newDate);
        getMachineHistory(newDate);
    };

    useEffect(() => {
        getMachineHistory();
    }, []);

    useEffect(() => {
        const days = document.querySelectorAll(
            ".react-calendar__month-view__days__day"
        );
        for (const item of days) {
            item.classList.remove("green", "red");
        }

        let isFirst = false;

        for (const item of days) {
            const dt = history?.history?.find((i) => i.date == item.innerText);
            if (item.innerText == 1) isFirst = true;

            if (dt && isFirst) {
                item.classList.add(dt.isActive ? "green" : "red");
            }
            if (
                isFirst &&
                item.innerText ==
                    history?.history[history?.history?.length - 1]?.date
            )
                break;
        }
    }, [history, date]);

    return (
        <Page title="Machines Details">
            <div className="qr-details">
                <div className="style-2">
                    <div className="style-5">
                        <div className="style-6">Name :</div>
                        <div className="style-9">{data?.nickName}</div>
                    </div>

                    <div className="style-14">
                        <div className="style-6">Code :</div>
                        <img src={qr} className="style-22" />
                    </div>

                    {/* <div className="style-5">
                        <div className="style-6">Status :</div>
                        <div className="style-9">Active</div>
                    </div> */}

                    <div className="style-5">
                        <div className="style-6">Heads :</div>
                        <div className="style-9">{data?.head}</div>
                    </div>

                    <div className="style-5">
                        <div className="style-6">Area :</div>
                        <div className="style-9">{data?.area}</div>
                    </div>
                </div>

                <div className="style-42">
                    <div className="celender">
                        <Calendar onChange={onChange} value={date} />
                    </div>

                    {history?.attendance?.map((item, index) => (
                        <div className="style-63" key={index}>
                            <Link className="style-64">
                                <div className="style-65">
                                    <div className="style-66">
                                        {moment(item?.createdAt).format(
                                            "DD/MM/YYYY"
                                        )}
                                    </div>
                                    <div className="style-69">
                                        {item?.shift == 0 ? "DAY" : "NIGHT"}
                                    </div>
                                </div>
                                <div className="style-72">
                                    {item?.production}
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </Page>
    );
};

export default MachinesDetails;
